<template>
  <div class="expired">
    <i class="material-icons">timelapse</i>
    <h3>This session has expired</h3>
  </div>
</template>

<script>
  export default {
    name: "TrackerExpired"
  }
</script>

<style lang="scss" scoped>
  .expired {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    i {
      font-size: 130px;
      color: #e1e1e1;
      margin-bottom: 10px;
    }
  }
</style>
